import { Component, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { Observable, Subject, pipe, of, combineLatest } from 'rxjs';
import { tap, takeUntil, map, shareReplay } from 'rxjs/operators';
import { PageName, ParamsType, Taxonomies } from '@app/constants';
import { DataService } from '@app/data';
import { ifHeightAnimation } from '@app/animations';

@Component({
  selector: 'app-video',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.less'],
  animations: [ifHeightAnimation]
})
export class VideoComponent implements OnDestroy {

  public currentTaxonomyPage$: Observable<Taxonomies> = this.data.currentTaxonomyPage$;
  public page: any = this.data.getCurrentPage();
  public pageName: PageName = this.page.pageName;
  public class: string = this.page.section;
  public subPages$: Observable<any[]> = this.data.getSubPages$();
  public queryParams$: Observable<ParamsType> = this.data.queryParams$.pipe(shareReplay({ bufferSize: 1, refCount: true }));
  public showRecommended$: Observable<boolean>;
  private unsubscribe$: Subject<void> = new Subject();

  
  constructor(
  	private data: DataService
  ) {

    this.showRecommended$ = combineLatest([
      this.currentTaxonomyPage$,
      this.queryParams$
    ]).pipe(
      map(([taxonomyPage, queryParams]) => {
        console.log('**** VideoComponent showRecommended$ taxonomyPage.url ', taxonomyPage.url);
        console.log('**** VideoComponent showRecommended$ queryParams ', queryParams);

        const show: boolean = taxonomyPage.url === '/komunita/pro-ukrajinu' && (!queryParams.podstranka || queryParams.podstranka.length < 1) && (!queryParams.stitky || queryParams.stitky.length < 1) && !queryParams.strana;
        return show;
      })
    );
    
    this.showRecommended$.pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
      console.log('**** VideoComponent showRecommended$ res ', res);
    });
  }

  ngOnDestroy(): void {
    //console.log('DataComponent ngOnDestroy');

    this.unsubscribe$.next();
    this.unsubscribe$.complete();    
  }

  public getSubPage = (parentSubPages: any[]): any[] => {
    //console.log('VideoComponent getSubPage parentSubPages ', parentSubPages);

    if (parentSubPages === undefined || parentSubPages.length === 0) {
      return [];
    }

    return parentSubPages.find(page => page.url === this.page.data.subPage).children;
  }

  public setScrollIntoView = (id: string): void => this.data.setScrollIntoView(id); 
  
}
